import { render, staticRenderFns } from "./ContribFornecedorConsulta.vue?vue&type=template&id=5e83504a&"
import script from "./ContribFornecedorConsulta.vue?vue&type=script&lang=js&"
export * from "./ContribFornecedorConsulta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports